<section>
  <div class="full-card-container">
    <div class="category-area">
      <div class="category {{task.category?.toLocaleLowerCase()?.replace(' ', '-')}}">{{task.category}}</div>
      <button class="close-button" (click)="boardService.openFullCard(task)"></button>
    </div>

    <div class="title">
      <h1>{{task.title}}</h1>
    </div>

    <div class="description">
      {{task.description}}
    </div>

    <div class="input">
      <span>Due date:</span>
      <p>{{task.dueDate}}</p>
    </div>

    <div class="input">
      <span>Priority:</span>
      <p>{{task.priority}}</p>
      <div [class]="task.priority.toLowerCase()"></div>
    </div>

    <div class="input-assigned-to">
      <span>Assigned To:</span>
      <div class="user-priority">
        @for (user of task.assignedTo; track $index) {
        <div class="user-details">
          <div class="user initials" [style.background]= user.color>{{ user.initials}} </div>
          <div class="user-name">{{user.firstName}} {{user.lastName}}</div>
        </div>

        }
      </div>
    </div>


    <div class="input-assigned-to">
      <span>Subtasks:</span>
      <div class="subtask-priority">
        @for (subtasks of task.subTaskFillTest; track $index) {
          @if (subtasks.completed == true) {
            <div class="subtask">
              <div (click)="toggleCheckbox($index)" class="checkbox-active"></div> {{subtasks.text}} 
            </div>
            } @else {
            <div class="subtask">
              <div (click)="toggleCheckbox($index)" class="checkbox"></div> {{subtasks.text}}
            </div>
          }
        }
      </div>
    </div>

    <div class="edit-delete-area">

      <div class="delete-container" (click)="boardService.deleteTask(task); boardService.openFullCard(task)">
        <div class="delete"></div>
        <p>Delete</p>
      </div>

      <div class="hyphen"></div>

      <div class="edit-container"  (click)="boardService.toggleEditOverlay()">
        <div class="edit"></div>
        <p>Edit</p>
      </div>

    </div>
  </div>

    @if (boardService.editOverlayActive == true) {
  <app-kanban-edit [task]="task"></app-kanban-edit>
  }
</section>